import {
  FC, memo, useCallback,
} from 'react';
import { createUseStyles } from 'react-jss';
import cn from 'classnames';

interface SearchProps {
  className?: string,
  disabled?: boolean,
  value?: string,
  onChange?: (text: string) => void,
}

const Search: FC<SearchProps> = (props) => {
  const {
    className,
    disabled,
    value,
    onChange,
  } = props;

  const classes = useStyles();

  const handleSearchText = useCallback((event: any) => {
    onChange?.(event.target.value);
  }, [onChange]);

  return (
    <div className={cn(className, classes.container, { disabled })}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.7628 21.3833L17.1693 15.7898C16.7882 15.4086 16.1709 15.4086 15.7898 15.7898C15.4086 16.1706 15.4086 16.7885 15.7898 17.1693L21.3833 22.7628C21.5738 22.9533 21.8233 23.0486 22.073 23.0486C22.3225 23.0486 22.5722 22.9533 22.7628 22.7628C23.1439 22.382 23.1439 21.7641 22.7628 21.3833Z" fill="#4A4A4A" />
        <path d="M9.61788 18.2358C4.86602 18.2358 1 14.3698 1 9.61792C1 4.86606 4.86602 1 9.61788 1C14.3697 1 18.2358 4.86602 18.2358 9.61788C18.2358 14.3697 14.3697 18.2358 9.61788 18.2358Z" strokeWidth="2" stroke="#4A4A4A" />
      </svg>
      <input placeholder="Search" onChange={handleSearchText} value={value} disabled={disabled} />
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    '&': {
      position: 'relative',
      background: '#ffffff',
      transition: '300ms background ease',
    },
    '&.disabled': {
      background: '#f5f5f5',
    },
    '& svg': {
      position: 'absolute',
      left: '1.5rem',
      top: '0.8rem',
      width: '2.2rem',
      height: '2.2rem',
      marginTop: '0.2rem',
      transition: '300ms opacity ease',
    },
    '&.disabled svg': {
      opacity: 0.5,
    },
    '& input': {
      width: '100%',
      border: '0.1rem solid #aaaaaa',
      borderRadius: '0.7rem',
      height: '2rem',
      color: '#3F3F3F',
      fontWeight: 400,
      fontSize: '1.8rem',
      outline: 'none',
      transition: '300ms color ease, 300ms border-color ease',
      background: 'transparent',
      padding: '1rem 0',
      textIndent: '5rem',
    },
    '& input[disabled]': {
      color: '#868686',
      background: 'transparent',
    },
    '& input::placeholder': {
      color: '#868686',
      fontWeight: 400,
      fontSize: '1.8rem',
    },
    '& input:focus': {
      borderColor: '#000000',
    },
  },
});

export default memo(Search);
